export function cachedMethod<This extends object, Return>(
  target: (this: This) => Return,
  context: ClassMethodDecoratorContext<This, (this: This) => Return>
): (this: This) => Return
export function cachedMethod<This extends object, Arg, Return>(
  target: (this: This, arg: Arg) => Return,
  context: ClassMethodDecoratorContext<This, (this: This, arg: Arg) => Return>
): (this: This, arg: Arg) => Return
export function cachedMethod<This extends object, Arg, Return>(
  target: (this: This, arg: Arg) => Return,
  context: ClassMethodDecoratorContext<This, (this: This, arg: Arg) => Return>
) {
  const key = Symbol(String(context.name) + '_cache')
  if (target.length) {
    context.addInitializer(function () {
      Object.defineProperty(this, key, {
        value: new Map<Arg, Return>()
      })
    })
    return function (this: This, arg: Arg) {
      const lookup = (this as This & { [key]: Map<Arg, Return> })[key]
      if (lookup.has(arg)) return lookup.get(arg)
      const value = target.call(this, arg)
      lookup.set(arg, value)
      return value
    }
  } else {
    return function (this: This, arg: Arg) {
      if (key in this) return this[key] as Return
      const value = target.call(this, arg)
      Object.defineProperty(this, key, { value })
      return value
    }
  }
}
